import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

import { InputComponent } from '@shared/components/input/input.component';
import { SelectComponent } from '@shared/components/select/select.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, SelectComponent, InputComponent, NgClass, NgSelectComponent],
  selector: 'aux-scenario-pages',
  styles: [],
  templateUrl: './scenario-dialog.component.html',
})
export class ScenarioDialogComponent {
  activeTabIndex = 0;
  milestoneOptions = ['Patient Enrollment'];
  quadrants = ['High', 'Mid to High', 'Mid to Low', 'Low', 'All Sites'];
  selectedTab = 'Timeline';
  tables = [
    {
      data: [
        { date: '02 / 20 / 2019 ', length: '20 days', milestone: 'Protocol Preparation' },
        { date: '03 / 08 / 2019', length: '20 days', milestone: 'Site Identification' },
        { date: '03 / 28 / 2019', length: '20 days', milestone: 'Site Initiation' },
        { date: '04 / 18 / 2019', length: '20 days', milestone: 'Patient Enrollment' },
        { date: '05 / 07 / 2019', length: '20 days', milestone: 'Treatment' },
      ],
      gray: false,
      header: 'Current Timeline',
    },
    {
      data: [
        { date: '02 / 20 / 2019 ', length: '20 days', milestone: 'Protocol Preparation' },
        { date: '03 / 08 / 2019', length: '20 days', milestone: 'Site Identification' },
        { date: '03 / 28 / 2019', length: '20 days', milestone: 'Site Initiation' },
        { date: '04 / 18 / 2019', length: '5 days', milestone: 'Patient Enrollment' },
        { date: '04 / 23 / 2019', length: '20 days', milestone: 'Treatment' },
      ],
      gray: true,
      header: 'Revised Timeline',
    },
  ];
  types = ['Timeline', 'Enrollment Rate', 'Site Additions', 'Site Distribution'];
}
